import React from 'react'
import {AiFillHtml5} from 'react-icons/ai'
import {IoLogoCss3, IoLogoJavascript} from 'react-icons/io'
import {BsFileEarmarkCodeFill} from 'react-icons/bs'
import {FaReact, FaNodeJs} from 'react-icons/fa'
import {BiCodeBlock} from 'react-icons/bi'
import { SiFastapi } from "react-icons/si";
import { SiExpress, SiMongodb, SiPython,SiGithub} from 'react-icons/si'
import SkillCard from './SkillCard'
import { VscCode } from "react-icons/vsc";
import { FaGitlab } from "react-icons/fa";

export default function Skills() {
  return (
    <>
    <h1 style={{textAlign:"center"}}>My Skills</h1>
    <div className='skills-container'>
        <SkillCard icon={<BsFileEarmarkCodeFill/>} language='C++'/>
        <SkillCard icon={<BiCodeBlock/>} language='DSA'/>
        <SkillCard icon={<AiFillHtml5/>} language='HTML'/>
        <SkillCard icon={<IoLogoCss3/>} language='CSS'/>
        <SkillCard icon={<IoLogoJavascript/>} language='JavaScript'/>
        <SkillCard icon={<FaReact/>} language='React.js'/>
        <SkillCard icon={<SiPython/>} language='Python'/>
        <SkillCard icon={<SiFastapi/>} language='fastAPI'/>
        <SkillCard icon={<FaNodeJs/>} language='Node.js'/>
        <SkillCard icon={<SiExpress/>} language='Express.js'/>
        <SkillCard icon={<SiMongodb/>} language='mongoDB'/>
        <SkillCard icon={<VscCode />} language='VS Code'/>
        <SkillCard icon={<FaGitlab />} language='Gitlab'/>
    </div>
    <p style={{"text-align":"justify", marginTop:"20%"}}>.</p>
    </>
  )
}
